import { CommonModule, DatePipe } from '@angular/common';
import { Component, Injector, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Coluna, Formats } from '../../models/mat-table-model';
import { Job } from '../../models/bas/job';
import { JobService } from '../../services/bas/job.service';
import { ESSENTIALS, MATERIAL_DATA, MATERIAL_LAYOUT } from '../../utils/shared-components';

@Component({
  selector: 'app-job-info',
  standalone: true,
  imports: [ESSENTIALS, MATERIAL_DATA, MATERIAL_LAYOUT],
  templateUrl: './job-info.component.html',
  styleUrl: './job-info.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [DatePipe]
})
export class JobInfoComponent implements OnInit {

  dialogRef: MatDialogRef<JobInfoComponent>;
  dialogData: any;

  displayedColumns: any;
  columns: Coluna[] = [];
  dataSource = new MatTableDataSource<Job>();
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;

  expandedElement: any | null = null;

  constructor(
    private service: JobService,
    private injector: Injector,
    private datePipe: DatePipe
  ) {
    this.dialogRef = this.injector.get(MatDialogRef);
    this.dialogData = this.injector.get(MAT_DIALOG_DATA, null);
  }

  ngOnInit(): void {

    this.columns = [
      new Coluna({
        columnDef: 'descricaoSituacao',
        header: 'Situação',
      }),
      new Coluna({
        columnDef: 'dataHoraInicio',
        header: 'Data Início',
        format: Formats.Datetime
      }),
      new Coluna({
        columnDef: 'dataHoraFim',
        header: 'Data Término',
        format: Formats.Datetime
      }),
    ];

    this.displayedColumns = this.columns.map(element => element.columnDef);

    this.displayedColumns.push('expand');

    this.buscarDados();
  }

  buscarDados() {
    this.service.buscaInformacoesJob(this.dialogData.nomeTabela, this.dialogData.idTabela).subscribe({
      next: (response) => {
        if (response.body) {
          this.dataSource.data = response.body.retorno.detalhe;
        }
      }
    });
  }

  closeModal() {
    this.dialogRef.close();
  }

  toggleRow(row: any) {
    this.expandedElement = this.expandedElement === row ? null : row;
  }

  isExpandedDetail = (_: number, row: any) => this.expandedElement === row;
}
